const moduleName = 'adviceLocalBackSync'
module.exports = moduleName;
const mod = angular.module(moduleName, [
  'dndLists'
])
  .config(($stateProvider) => {
    $stateProvider
      .state('adviceLocalBackSync', {
        url: '/adviceLocalBackSync',
        template: require('./adviceLocalBackSync.html'),
        controller: 'adviceLocalBackSyncCtrl'
      })
  })


require('./adviceLocalBackSyncCtrl')(mod)
